import { CSSProperties } from "react";

export const antLayoutSider: CSSProperties = {
  position: "relative",
  boxShadow: "2px 0 8px rgba(0, 0, 0, 0.06)",
};
export const antLayoutSiderMobile: CSSProperties = {
  position: "fixed",
  height: "100vh",
  zIndex: 999,
};
